
import Shimmer from "@/components/ui/shimmer";

export const RoutineShimmer = () => {
  return (
    <div className="space-y-4 transition-colors duration-300">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="bg-card/30 dark:bg-card/20 sunset:bg-orange-800/20 forest:bg-green-800/20 ocean:bg-blue-800/20 rounded-lg p-4 border border-border/30 transition-colors duration-300">
          <div className="flex items-center justify-between mb-4">
            <div className="flex-1">
              <Shimmer className="h-6 w-48 mb-2" />
              <Shimmer className="h-4 w-32" />
            </div>
            <Shimmer className="h-8 w-8 rounded-md" />
          </div>
          <div className="space-y-3">
            {[...Array(2)].map((_, j) => (
              <div key={j} className="bg-card/50 dark:bg-card/30 sunset:bg-orange-800/30 forest:bg-green-800/30 ocean:bg-blue-800/30 rounded-lg p-4 border border-border/20 transition-colors duration-300">
                <Shimmer className="h-5 w-36 mb-2" />
                <div className="flex gap-4">
                  <Shimmer className="h-4 w-16" />
                  <Shimmer className="h-4 w-16" />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
